export enum PayinStatisticsGroupBy {
  Provider = 'provider',
  Shop = 'shop',
  ProviderShop = 'provider_shop',
}
